/**************
 * 以下维护本模块内点击跳转的链接
 * 后续本模块跳到提报，或者间接跳提报的都集中在这里维护
 *************/
import { getDataThrowToMicroapp } from '@/pages/activity-manage/merchants/venue-detail/constants/index';
import { goto } from '@/common/goto';
import { ACTIVITYRECEIPTTYPEENUM } from './activity-receipt-config';

/* 新建活动跳转 */
export function gotoNewBuildActivity() {
  const { jumpActivityCreate } = getDataThrowToMicroapp({ baseLink: `/activity-manage/myCreate` });
  jumpActivityCreate('');
}

/* 活动跳转【我的管理时，entry=0,活动参与者时为entry=1】 */
export function gotoActivity(activeTab, baseInfo) {
  if (baseInfo.createSource && baseInfo.createSource == 4) {
    if (activeTab == 'APPLY') {
      // 报名端 区分新老日常活动
      goto(
        `/activity-manage/myCreate/daily-activities-operation/pitEnroll/roomlist?entry=${
          activeTab === ACTIVITYRECEIPTTYPEENUM.MANAGE.key ? 0 : 1
        }&activityId=${baseInfo?.id}&from=acore&hideTab=1&id=${baseInfo?.id}`,
        'newTab'
      );
    } else {
      // 管理端
      goto(
        `/activity-manage/myCreate/daily-activities-manager/materials?entry=${
          activeTab === ACTIVITYRECEIPTTYPEENUM.MANAGE.key ? 0 : 1
        }&activityId=${baseInfo?.id}&from=acore&hideTab=1&id=${baseInfo?.id}&receivingType=1`,
        'newTab'
      );
    }
  } else {
    goto(
      `/activity-manage/myCreate/pools/roomlist?entry=${
        activeTab === ACTIVITYRECEIPTTYPEENUM.MANAGE.key ? 0 : 1
      }&activityId=${baseInfo?.id}&from=acore&hideTab=1&id=${baseInfo?.id}`,
      'newTab'
    );
  }
}

/* 待我报名收品池跳转【applyValidStatus=1 待报名收品池选中】【我的管理中无待我报名收品池所以entry为1】 */
export function gotoWaitAreaActivity(baseInfo) {
  // 新活动跳转新的地址【和进入活动一个地址,多个参数】
  if (baseInfo?.createSource && baseInfo?.createSource == 4) {
    goto(
      `/activity-manage/myCreate/daily-activities-operation/pitEnroll/roomlist?entry=1&activityId=${baseInfo?.id}&from=acore&hideTab=1&id=${baseInfo?.id}&applyValidStatus=1`,
      'newTab'
    );
  } else {
    goto(
      `/activity-manage/myCreate/pools/roomlist?entry=1&activityId=${baseInfo?.id}&from=acore&hideTab=1&id=${baseInfo?.id}&applyValidStatus=1`,
      'newTab'
    );
  }
}

/* 待完善商品素材跳转【待完善商品素材0331新加的，所以新活动才能跳转，老活动不行】*/
export function gotoWaitImprovedActivity(baseInfo) {
  // 跳转“点击可跳转至活动详情页&定位在完善商品素材tab”
  // http://test1.yx.jd.com/activity-manage/myCreate/daily-activities-operation/materialMaintenance?entry=1&activityId=10629085&from=acore&hideTab=1&id=10629085
  if (baseInfo?.createSource && baseInfo?.createSource == 4) {
    goto(
      `/activity-manage/myCreate/daily-activities-operation/materialMaintenance?entry=1&activityId=${baseInfo?.id}&from=acore&hideTab=1&id=${baseInfo?.id}`,
      'newTab'
    );
  }
}

/* 待我审核素材数跳转【tab=2 待审核的】 */
export function gotoWaitCheckActivity(baseInfo) {
  goto(`/activity-manage/myCreate/room/check?tab=2&activityid=${baseInfo?.id}`, 'newTab');
}

/* 收品池列表查看详情和名称跳转【blockid带上即可选中当前收品】 */
export function gotoReceiptDetail(activeTab, baseInfo) {
  if (baseInfo.createSource && baseInfo.createSource == 4) {
    if (activeTab == 'APPLY') {
      // 报名端 区分新老日常活动
      goto(
        `/activity-manage/myCreate/daily-activities-operation/pitEnroll/roomlist?entry=${
          activeTab === ACTIVITYRECEIPTTYPEENUM.MANAGE.key ? 0 : 1
        }&activityId=${baseInfo.activityId}&from=acore&hideTab=1&id=${baseInfo.activityId}&blockid=${baseInfo.id}`,
        'newTab'
      );
    } else {
      // 管理端
      goto(
        `/activity-manage/myCreate/daily-activities-manager/materials?entry=${
          activeTab === ACTIVITYRECEIPTTYPEENUM.MANAGE.key ? 0 : 1
        }&activityId=${baseInfo.activityId}&from=acore&hideTab=1&id=${baseInfo.activityId}&blockid=${
          baseInfo.id
        }&receivingType=1`,
        'newTab'
      );
    }
  } else {
    goto(
      `/activity-manage/myCreate/pools/roomlist?entry=${
        activeTab === ACTIVITYRECEIPTTYPEENUM.MANAGE.key ? 0 : 1
      }&activityId=${baseInfo.activityId}&from=acore&hideTab=1&id=${baseInfo.activityId}&blockid=${baseInfo.id}`,
      'newTab'
    );
  }
}
